var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcAngleLeft({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 20,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M.786 10.714l8.994 8.99a1.013 1.013 0 001.43 0 1.008 1.008 0 000-1.426l-8.28-8.277 8.279-8.278a1.009 1.009 0 000-1.428 1.013 1.013 0 00-1.43 0L.785 9.286a1.02 1.02 0 00.001 1.428z",
    fill: "#646D7C"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcAngleLeft);
export default __webpack_public_path__ + "static/media/ic-angle_left.bf723f71263cccb0b7f939b7a88e5e74.svg";
export { ForwardRef as ReactComponent };